/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HighRiskModel
 */
export interface HighRiskModel {
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof HighRiskModel
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    highRiskStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HighRiskModel
     */
    fileSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof HighRiskModel
     */
    fileId?: string | null;
}

/**
 * Check if a given object implements the HighRiskModel interface.
 */
export function instanceOfHighRiskModel(value: object): value is HighRiskModel {
    return true;
}

export function HighRiskModelFromJSON(json: any): HighRiskModel {
    return HighRiskModelFromJSONTyped(json, false);
}

export function HighRiskModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighRiskModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'highRiskStatus': json['highRiskStatus'] == null ? undefined : json['highRiskStatus'],
        'note': json['note'] == null ? undefined : json['note'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileSizeBytes': json['fileSizeBytes'] == null ? undefined : json['fileSizeBytes'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
    };
}

export function HighRiskModelToJSON(json: any): HighRiskModel {
    return HighRiskModelToJSONTyped(json, false);
}

export function HighRiskModelToJSONTyped(value?: HighRiskModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'highRiskStatus': value['highRiskStatus'],
        'note': value['note'],
        'fileName': value['fileName'],
        'fileSizeBytes': value['fileSizeBytes'],
        'fileId': value['fileId'],
    };
}

